import { FC } from 'react';
import { Col, Row } from 'antd';
import i18next from 'i18next';

import { PageContentContainer } from '~src/styles/containers.sc';
import SvgIcon from '~src/shared/SvgIcon';

import {
  ContactHeaderSubTitle,
  ContactHeaderTitle,
  ContactHeaderWrapper,
  IconsBox,
} from './contactUsHeader.sc';

interface Props {
  t: i18next.TFunction;
  isLoggedIn: boolean;
}

const ContactHeader: FC<Props> = ({ t, isLoggedIn }) => (
  <ContactHeaderWrapper $isLoggedIn={isLoggedIn}>
    <PageContentContainer>
      <Row gutter={30}>
        <Col lg={12}>
          <ContactHeaderTitle data-translation="x.contact.header.title">
            {t('x.contact.header.title')}
          </ContactHeaderTitle>
          <ContactHeaderSubTitle data-translation="x.contact.header.subtitle">
            {t('x.contact.header.subtitle')}
          </ContactHeaderSubTitle>
        </Col>
        <Col lg={8} offset={4} style={{ marginTop: '15px' }}>
          <IconsBox>
            <a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/looplinesystems/">
              <SvgIcon name="iconFacebook" width="30px" />
            </a>
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://twitter.com/looplinesys?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
            >
              <SvgIcon name="iconTwitter" width="30px" />
            </a>
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.youtube.com/channel/UC_PjcqqCx9x4q_iwbdZ_uPA"
            >
              <SvgIcon name="iconYoutube" width="30px" />
            </a>
            <a target="_blank" rel="noreferrer noopener" href="https://www.instagram.com/loopline.systems/">
              <SvgIcon name="iconInstagram" width="30px" />
            </a>
          </IconsBox>
        </Col>
      </Row>
    </PageContentContainer>
  </ContactHeaderWrapper>
);

export default ContactHeader;
